import { BdFraudEnforcementMode } from 'us-web-services';

export const BD_SIGNAL_TYPE_LABELS: Record<string, string> = {
  EMAIL: 'Email',
  PHONE: 'Phone',
  NAME: 'Name',
  ADDRESS: 'Address',
  IP: 'IP Address',
  DEVICE_TOKEN: 'Device',
  USER_AGENT: 'User Agent',
};

export const BD_TIER_LABELS: Record<string, string> = {
  CONFIRMED: 'Confirmed',
  MEDIUM: 'Medium',
  LOW: 'Low',
};

export const BD_OUTCOME_LABELS: Record<string, string> = {
  ALLOWED: 'Allowed',
  OBSERVED: 'Observed',
  HELD_FOR_REVIEW: 'Held for Review',
  BLOCKED: 'Blocked',
  RETROACTIVE_SCAN: 'Retroactive Scan',
};

export const BD_RESOLUTION_LABELS: Record<string, string> = {
  CONFIRMED_FRAUD: 'Confirmed Fraud',
  LEGITIMATE: 'Legitimate',
};

export const BD_ENFORCEMENT_OPTIONS: {
  value: BdFraudEnforcementMode;
  label: string;
  description: string;
}[] = [
  {
    value: 'OFF',
    label: 'Off',
    description: 'BD fraud check is disabled. No evaluations are run.',
  },
  {
    value: 'OBSERVE',
    label: 'Observe',
    description: 'Evaluations run and log to the queue, but no booking is blocked.',
  },
  {
    value: 'ENFORCE',
    label: 'Enforce',
    description:
      'Confirmed-tier matches block booking creation with a parent-facing error and an immediate '
      + 'email to support@urbansitter.com; medium-tier matches queue for same-day review.',
  },
];
